<div class="stacked-progress-root">
  <div
    class="stacked-progress-container"
    [style.height.px]="height()"
  >
    <div class="stacked-progress-bar">
      @for (segment of normalizedSegments(); track $index) {
        <div
          class="stacked-progress-segment"
          [style.flex-basis.%]="segment.percentage"
          [style.background-color]="'var(' + segment.color + ')'"
          [matTooltip]="segment.tooltip || ''"
        ></div>
      }
    </div>
  </div>
</div>

